import i18n from "i18next";

import { aniaLayerColourMappingFiveLevels } from "../policy/policyMapStyle";
import { ClimateIndexLegend } from "../legends/ClimateIndexLegend";
import { ItaAniaWindLegend } from "../legends/ItaAniaWindLegend";
import { CystellarNaturalEventsDetails } from "./sidebarComponents/CystellarNaturalEventsDetails";
import { CystellarNonCatastropheDetails } from "./sidebarComponents/CystellarNonCatastropheDetails";
import { AniaNaturalEventsDetails } from "./sidebarComponents/AniaNaturalEventsDetails";
import { AniaNaturalCatastropheDetails } from "./sidebarComponents/AniaNaturalCatastropheDetails";
import { ANIA_ENUM } from "../util/AniaEnums";

import { legendStyle } from "../legends/style";
import { PermissionIdEnum } from "../util/types/permissions/permissionIdEnum";

export const RiskIndexesLayerId = "riskIndexes";

export const lineLayer = {
  id: "data",
  type: "line",
  paint: {
    "line-width": 0.3,
    "line-color": "#0080ef",
  },
};

export const riskIndexesFillLayer = (propertyName) => {
  return {
    id: RiskIndexesLayerId,
    type: "fill",
    paint: {
      "fill-color": [
        "step",
        ["get", propertyName],
        "#4d6dbd",
        10,
        "#4d6dbd",
        20,
        "#509bc7",
        40,
        "#f1d55d",
        60,
        "#e07069",
        80,
        "#c7445d",
        100, // very high
        "#c7445d",
      ],
      "fill-opacity": 0.7,
    },
  };
};

export const aniaNaturalEventsIndexFillLayer = {
  id: RiskIndexesLayerId,
  type: "fill",
  paint: {
    "fill-color": ["step", ["get", "ANIA_RINDX_ITA_NE"], "#ffffff", ...aniaLayerColourMappingFiveLevels],
    "fill-opacity": 0.7,
  },
};

export const aniaNaturalCatastropheIndexFillLayer = {
  id: RiskIndexesLayerId,
  type: "fill",
  paint: {
    "fill-color": ["step", ["get", "ANIA_RINDX_ITA_NCAT"], "#ffffff", ...aniaLayerColourMappingFiveLevels],
    "fill-opacity": 0.7,
  },
};

export const riskLayersEnum = () => {
  return {
    cystellarNaturalEvents: {
      id: "cystellarNaturalEvents",
      label: i18n.t("climateIndex.CysNe"),
      mapLayer: riskIndexesFillLayer("cys_rindx_ITA_PC_NE"),
      propertyName: "cys_rindx_ITA_PC_NE",
      legend: <ClimateIndexLegend title={i18n.t("climateIndex.CysNe")} />,
      sidePanelComponent: CystellarNaturalEventsDetails,
      geojsonUrl: "https://d24ye0ax7gglwd.cloudfront.net/analytics-climate-index/cys_rindx_ITA_PC_NE_opt.zip",
    },
    cystellarNonCatastrophe: {
      id: "cystellarNonCatastrophe",
      label: i18n.t("climateIndex.CysNcat"),
      mapLayer: riskIndexesFillLayer("cys_rindx_ITA_NCAT"),
      propertyName: "cys_rindx_ITA_NCAT",
      legend: <ClimateIndexLegend title={i18n.t("climateIndex.CysNcat")} />,
      sidePanelComponent: CystellarNonCatastropheDetails,
      geojsonUrl: "https://d24ye0ax7gglwd.cloudfront.net/analytics-climate-index/cys_rindx_ITA_NCAT_opt.zip",
    },
    aniaNaturalEvents: {
      id: "aniaNaturalEvents",
      label: i18n.t("climateIndex.AniaNe"),
      // permissions: ["CYS_ANIA_NATURAL_EVENTS_MAP"],
      permissions: [PermissionIdEnum.AniaNatEventsIndex],
      mapLayer: aniaNaturalEventsIndexFillLayer,
      propertyName: "ANIA_RINDX_ITA_NE",
      legend: (
        <ItaAniaWindLegend
          aniaEnum={ANIA_ENUM.ANIA_LEGEND}
          customLegendStyle={{ ...legendStyle, right: "", left: "12px", top: "30px" }}
          title={i18n.t("climateIndex.AniaNe")}
        />
      ),
      sidePanelComponent: AniaNaturalEventsDetails,
      geojsonUrl: "https://d24ye0ax7gglwd.cloudfront.net/ania/cys_hazards_ania_v2_opt.zip",
      //geojsonUrl:
      //  "https://d24ye0ax7gglwd.cloudfront.net/analytics-climate-index/ania_rindx_ita_ne.geojson",
    },
    aniaNonCatastrophe: {
      id: "aniaNonCatastrophe",
      label: i18n.t("climateIndex.AniaNcat"),
      // permissions: ["CYS_ANIA_NON_CATASTROPHE_MAP"],
      permissions: [PermissionIdEnum.AniaNonCatIndex],
      mapLayer: aniaNaturalCatastropheIndexFillLayer,
      propertyName: "ANIA_RINDX_ITA_NCAT",
      legend: (
        <ItaAniaWindLegend
          aniaEnum={ANIA_ENUM.ANIA_LEGEND}
          customLegendStyle={{ ...legendStyle, right: "", left: "12px", top: "30px" }}
          title={i18n.t("climateIndex.AniaNcat")}
        />
      ),
      sidePanelComponent: AniaNaturalCatastropheDetails,
      geojsonUrl: "https://d24ye0ax7gglwd.cloudfront.net/ania/cys_hazards_ania_v2_opt.zip",
      //geojsonUrl:
      //  "https://d24ye0ax7gglwd.cloudfront.net/analytics-climate-index/ania_rindx_ita_ne.geojson",
    },
  };
};
